import React from 'react';
import PropTypes from 'prop-types';

// The logo path (shared with the server-rendered boot logo).
import logoPath, { viewBox } from './path';

// Styled.
import * as S from './styled';

/**
 * Renders the "Exonet" logo.
 *
 * @param {string} className The optional className.
 *
 * @returns {Element} The SVG logo.
 */
const Logo = ({ className = '' }) => (
  <S.Logo className={className} xmlns="http://www.w3.org/2000/svg" viewBox={viewBox}>
    <path d={logoPath} />
  </S.Logo>
);

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
